import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'

export default class extends Controller {
  static values = {
    options: Object,
    defaultDate: String,
  }

  connect() {
    const defaultOptions = {
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'F j, Y',
      allowInput: true,
      disableMobile: true,
    }

    // Set defaultDate if provided
    if (this.hasDefaultDateValue) {
      defaultOptions.defaultDate = this.defaultDateValue
    }

    const options = { ...defaultOptions, ...this.optionsValue }
    this.flatpickr = flatpickr(this.element, options)
  }

  disconnect() {
    if (this.flatpickr) {
      this.flatpickr.destroy()
    }
  }
}
